import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeSubclassReadAction from './cnaeSubclassRead.action.json' with { type: 'json' }

const cnaeSubclassReadDefinition = defineReadAutoAction(cnaeSubclassReadAction, 'cnaeSubclass')

export default cnaeSubclassReadDefinition
